import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  format() {
    const alphaNumericOnly = this.element.value
      .toLowerCase()
      .replace(/[^0-9a-f]/g, '')
      .slice(0, 12);

    const groups = alphaNumericOnly.match(/.{1,2}/g) || [];
    this.element.value = groups.join(':');
  }
}
